// Quantity selector
document.addEventListener('DOMContentLoaded', function() {
  // Quantity buttons
  const quantityMinusButtons = document.querySelectorAll('.quantity-minus');
  const quantityPlusButtons = document.querySelectorAll('.quantity-plus');

  quantityMinusButtons.forEach(button => {
    button.addEventListener('click', function() {
      const input = this.nextElementSibling;
      const currentValue = parseInt(input.value);
      if (currentValue > 1) {
        input.value = currentValue - 1;
      }
    });
  });

  quantityPlusButtons.forEach(button => {
    button.addEventListener('click', function() {
      const input = this.previousElementSibling;
      const currentValue = parseInt(input.value);
      input.value = currentValue + 1;
    });
  });

  // Product image gallery
  const thumbnails = document.querySelectorAll('.thumbnail');
  const mainImage = document.querySelector('.main-image img');

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      const newImageSrc = this.dataset.image;
      if (mainImage && newImageSrc) {
        mainImage.src = newImageSrc;
      }

      // Update active thumbnail
      thumbnails.forEach(t => t.classList.remove('ring-4', 'ring-emerald-600'));
      thumbnails.forEach(t => t.classList.add('ring-2', 'ring-gray-200'));
      this.classList.remove('ring-2', 'ring-gray-200');
      this.classList.add('ring-4', 'ring-emerald-600');
    });
  });

  // Add to cart buttons (quick add)
  const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const variantId = this.dataset.productId;

      if (!variantId) return;

      // Add to cart via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Update cart count
        updateCartCount();

        // Show success message
        showNotification('Produkt tilføjet til kurv!');
      })
      .catch(error => {
        console.error('Error:', error);
        showNotification('Kunne ikke tilføje produkt', 'error');
      });
    });
  });

  // Update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          cartCount.textContent = data.item_count;
        }
      });
  }

  // Show notification
  function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `fixed bottom-8 right-8 z-50 px-6 py-4 rounded-xl shadow-2xl transition-all duration-300 ${
      type === 'success' ? 'bg-emerald-600' : 'bg-red-600'
    } text-white font-semibold`;
    notification.textContent = message;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.opacity = '0';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
});

// Search toggle (implement based on your search design)
function openSearch() {
  // Implement your search modal/overlay here
  console.log('Search opened');
}

// Cart Drawer Custom Element
if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    }

    open() {
      this.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      
      // Focus drawer
      const drawer = this.querySelector('.drawer__inner');
      if (drawer) {
        setTimeout(() => {
          drawer.focus();
        }, 100);
      }
    }

    close() {
      this.classList.remove('active');
      setTimeout(() => {
        this.classList.remove('animate');
      }, 400);
      document.body.classList.remove('overflow-hidden');
    }
  });
}

// Cart Drawer Items Component
if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', class CartDrawerItems extends HTMLElement {
    constructor() {
      super();

      this.debouncedOnChange = this.debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }

    updateQuantity(line, quantity) {
      this.enableLoading(line);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);

          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.disableLoading();
        })
        .catch(() => {
          this.disableLoading();
        });
    }

    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        }
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document.getElementById('CartDrawer').querySelectorAll('.loading-overlay')[line - 1].classList.remove('hidden');
      document.activeElement.blur();
    }

    disableLoading() {
      document.getElementById('CartDrawer').querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  });
}

// Cart Remove Button
if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-drawer-items') || this.closest('cart-items');
        cartItems.updateQuantity(this.dataset.index, 0);
      });
    }
  });
}

// Quantity Input Component
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })

      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  });
}

// Cart Note Component
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  });
}

// Helper function for fetch config
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
